/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import 'react-image-lightbox/style.css';

const onRouteUpdate = ({ location }) => {
  if (location && location.hash) {
    setTimeout(() => {
      const anchorElement = document.querySelector(`${location.hash}`);
      if (anchorElement) {
        anchorElement.scrollIntoView();
      } else {
        console.warn(`Couldn't scroll to anchor element "${location.hash}"`)
      }
    }, 0);
  }
};

export {
  onRouteUpdate
};